export const sortArray = (array, key) => {
  return array.sort((a, b) => {
    return b[key] - a[key]
  })
}



// WEBPACK FOOTER //
// ./src/utils/sortArray.js